import * as React from "react";
import "../../../styles/component/rich-text-view.scss";
import { sanitizeRichTextForRender } from "./rich-text-sanitizer";

export const RichTextView = (props: {
    content: string;
    diffMode?: boolean;
}) => {
    // Render-time XSS backstop: strip dangerous markup (meta/iframe/object/form/
    // script/event-handlers/js: URIs) before injecting stored HTML into the DOM,
    // while preserving legitimate editor markup and permissioned-content markers.
    const safeContent = React.useMemo(
        () => sanitizeRichTextForRender(props.content),
        [props.content]
    );
    return <div dangerouslySetInnerHTML={{ __html: safeContent }} className={"rich-text-view" + (!!props.diffMode ? " text-diff" : "")} />;
};
